// extracted by mini-css-extract-plugin
export var leftAlign = "_j-2";
export var popper = "_j-0";
export var subtitle = "_j-1";